module.exports = __webpack_public_path__ + "static/media/waterfall_logo.26b9e18a.png";